import AdyenAddCreditCard from './AdyenAddCreditCard';

export default AdyenAddCreditCard;
